module.exports = __webpack_public_path__ + "img/组 6014@2x.c5e4a58c.png";